import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BasicLoadConfigurationOptionsComponent } from '~modules/connectors/modules/load/common/components/basic-configuration-options/basic-load-configuration-options.component';
import { FileDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

@Component({
  selector: 'app-load-ecr-download-configuration',
  templateUrl: './load-ecr-download-configuration.component.html',
  styleUrls: ['./load-ecr-download-configuration.component.scss'],
  standalone: true,
  providers: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    MatRadioModule,
    MatTooltipModule,
    MatSlideToggleModule,
    BasicLoadConfigurationOptionsComponent
  ]
})
export class LoadEcrDownloadConfigurationComponent {
  formGroup!: FormGroup;
  configuration?: FileDownloadFieldsConfiguration;
  configurationMode: string | undefined;

  @Input()
  set configMode(configMode: string | undefined) {
    this.configurationMode = configMode;
  }

  @Input()
  set config (config: FileDownloadFieldsConfiguration | null) {
    if (config != null) {
      this.configuration = config;
    }
  }

  constructor(
    private readonly fb: FormBuilder,
  ) {
    this.formGroup = fb.group({
      folderId: [null, [Validators.required, Validators.maxLength(8)]],
      withPublicUrl: [true, Validators.required],
    });
  }
}
